/* eslint-disable @typescript-eslint/no-floating-promises */
import { Box } from "@chakra-ui/react"
import React from "react"
import { FMPTableType } from "../../../common/commonConstants"
import FMPProjectTable from "../fmpProjectTable/fmpProjectTable"
// import { useAtom } from 'jotai'
// import { sortedOrderAtom } from '../fmpProjectTable/fmpSortedOrder.store'
// import { useReOrderFmpProductsMutation } from '../../../type-and-hooks'
// import useErrorToast from '../../../common/commonHooks/errorToast'
// import { userDetailsAtom } from '../../../components/Menu/menu.store'

interface ViewFireManagementPlanTableProps {
  fmpId: number | undefined
  refToPass: React.RefObject<HTMLDivElement>
}

export const ViewFireManagementPlanTable: React.FC<ViewFireManagementPlanTableProps> = ({ fmpId, refToPass }): JSX.Element => {
  // const navigate = useNavigate()
  // const handleBackClick = (): void => {
  //   navigate(-1)
  // }
  // const [userDetails] = useAtom(userDetailsAtom)
  // const [reorderProject, { loading: reorderProjectLoading, error }] = useReOrderFmpProductsMutation()
  // const toast = useToast()
  // useErrorToast({ error, toast, errorMessage: 'Error updating FMP' })
  // const [getSortedOrderAtom] = useAtom(sortedOrderAtom)
  // const handleSave = (): void => {
  //   if (fmpId && userDetails?._id) {
  //     reorderProject({
  //       variables: {
  //         fmpProjectId: fmpId,
  //         userId: userDetails?._id,
  //         input: getSortedOrderAtom.map((item, index) => ({ id: Number(item.rowId), serial_no: index + 1 }))
  //       }
  //     })
  //   }
  // }
  return (
    <Box pos="relative">
      <Box ref={refToPass}>
        <FMPProjectTable fmpId={fmpId} tableType={FMPTableType.VIEW_FMP} />
      </Box>
      {/* <Flex align={'center'} justify={'center'} m="4" mt="12">
        <Button variant={'linkButton'} onClick={handleBackClick} fontWeight={400} fontSize={'16px'}>
          Back
        </Button>
        <Button
          variant="Button1RegularOutline"
          isLoading={reorderProjectLoading}
          onClick={handleSave}
          m="2"
          border={`1px solid ${Colors.Primary.c1}`}
          fontSize="16px"
          fontWeight={400}
        >
          Save -1
        </Button>
      </Flex> */}
    </Box>
  )
}
